import { connect } from "react-redux";

import { setToModel } from "../../../Engine/ActionCreators/AllActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withExternalMountingEventReporting } from "../../Services/ExternalMountingEventReporting/withExternalMountingEventReporting";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { FormActionHandler } from "../../Internals/FormActionHandlers/FormActionHandler";
import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";
import { withDisabledByParent } from "../../withDisabledByParent";

import { Checkbox, CheckboxValue } from "./Checkbox";

interface CheckboxContainerProps extends FormActionHandlerExecutionInjectableProps {
    bindingPath: AbsoluteResolvedModelPath;
    viewModelSelect: ViewModelSelect;
    disabled2?: EvaluableProp<boolean>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
    callHelperOnChange: FormActionHandler;
}

const mapStateToProps = (state: FullFormState, ownProps: CheckboxContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;

    // 'Sad' По умолчанию false, что не соответствует checkedValue, uncheckedValue
    // или какому-то другому.
    // Ошибка не хранилась в модели, не понятно нужна ли она там
    const controlModel = viewModelSelect.controlModel(state, bindingPath);

    return {
        value: controlModel.value ?? false,
        error: controlModel.error,
        // чиним проблему с побеждающим warning над error
        // это проблема react-ui, чинить пока не будут https://kontur.slack.com/archives/C013HTCE18Q/p1698216340082039
        warning: controlModel.error ? undefined : controlModel.warning,
        disabled: ownProps.processEvaluableProp(state, ownProps.disabled2),
        isReadOnly: state.settings.isReadOnly,
        isFormReloading: state.formVisualState.isFormReloading,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: CheckboxContainerProps) => {
    const { bindingPath } = ownProps;

    return {
        onChange: async (value: undefined | CheckboxValue) => {
            dispatch(setToModel(bindingPath, "value", value));
            if (isNotNullOrUndefined(ownProps.callHelperOnChange)) {
                await ownProps.executeFormActionHandler(ownProps.callHelperOnChange);
            }
        },
        setCorrectValue: (value: undefined | CheckboxValue) => dispatch(setToModel(bindingPath, "value", value)),
        setError: (error: boolean) => {
            dispatch(setToModel(bindingPath, "error", error ? [error] : []));
        },
    };
};

export const CheckboxContainer = withResolvePaths(
    withFormActionHandlerExecution(
        withDisabledByParent(
            withViewModelSelect(
                withEvaluators(
                    connect(
                        mapStateToProps,
                        mapDispatchToProps
                    )(
                        withTestPageObjectRegistration(
                            withFocusManagement(withExternalMountingEventReporting(withControlDebugInfo(Checkbox)))
                        )
                    )
                )
            )
        )
    )
);
